import { render, staticRenderFns } from "./TaskSto.vue?vue&type=template&id=4bb50b92&scoped=true"
import script from "./TaskSto.vue?vue&type=script&lang=js"
export * from "./TaskSto.vue?vue&type=script&lang=js"
import style0 from "./TaskSto.vue?vue&type=style&index=0&id=4bb50b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb50b92",
  null
  
)

export default component.exports